
import React, { Component } from "react";
import ChatWindow from "./ChatWindow";
import styles from "./chatStyle";
import { withStyles } from "@material-ui/core/styles";
import { withTheme, IconButton } from "@material-ui/core";
import { compose } from "recompose";
import { inject } from "mobx-react";
import Header from "./common/Header";
import { Close as CloseButton } from "./common/Buttons";
import { v4 as uuidv4 } from "uuid";
import {
  postData,
  getDataWithQueryString,
} from "../../../../api/componentAPIs"
import { withUserProfile } from "../../../../userProfile/userProfileContext";
import Events from "../../../../utilities/EventEmitter"
import { WithChatWindow } from "./common";
import MessageActionMenu from "./Header/MessageActionMenu";
import Tooltip from "../../../common/StyledToolTip";
import MoreVert from "@material-ui/icons/MoreVert";
import MessageHistory from "./MessageHistory";
import { getPreparedMessageData } from "./utils";
import { getDefaultDateRange } from "./MessageHistory/utils";
import { sanitizeInput } from "../../../../utilities/dataUtils";
import AuthService from "../../../../auth/AuthService";

@inject("DispatchStore")
class ChatContainer extends Component {
  constructor() {
    super();
    this.state = {
      openCannedMessages: false,
      messageList: [],
      driver: null,
      loadingMessages: false,
      openChoiceMessages: false,
      isChoiceMessageDisabled: false,
      anchorEl: null,
      openMessageHistory: false,
    };
  }

  componentDidMount() {
    this.fetchInfo(this.props.driverId);
    Events.on("DispatcherMessageRead", this.markDispatcherMessageAsRead);
    Events.on("MessageFromDriver", this.onMessageFromDriver);
  }

  componentWillUnmount() {
    Events.off("DispatcherMessageRead", this.markDispatcherMessageAsRead);
    Events.off("MessageFromDriver", this.onMessageFromDriver);
  }

  componentDidUpdate(prevProps) {
    if (prevProps.driverId !== this.props.driverId) {
      this.setState({
        openCannedMessages: false,
      });
      this.fetchInfo(this.props.driverId);
    }
  }

  disableChoiceMessageIcon = (isDisabled) => {
    this.setState({
      isChoiceMessageDisabled: isDisabled,
    })
  }

  fetchInfo = (driverId) => {
    const driver = this.props.DispatchStore.getCurrentDriver(driverId);
    this.setState({
      driver: driver,
      loadingMessages: true,
      messageList: [],
      unReadCount: driver.unReadCount
    });

    getDataWithQueryString(
      "GetAllMessages",
      `terminalCode=${this.props.userData.userProfile.terminal.code}&driverId=${driverId}`,
    ).then((response) => {
      if (response && response.status === 200) {
        const messageList = getPreparedMessageData(response.data);
        this.setState(
          {
            loadingMessages: false,
            messageList,
          },
          () => {
            this.markAllDriverMessageAsRead();
          },
        );
      }
    });
  };

  markDispatcherMessageAsRead = (dispatchMessageString) => {
    if (this.state.messageList.length) {
      const dispatchMessage = JSON.parse(dispatchMessageString);
      let isMessageMarked = false;
      const updatedMessageList = this.state.messageList.map((message) => {
        if (
          message.messageId.toUpperCase() ===
          dispatchMessage.messageId.toUpperCase()
        ) {
          message.isRead = true;
          isMessageMarked = true;
        }
        return message;
      });
      if (isMessageMarked) {
        this.setState({
          messageList: updatedMessageList,
        });
      }
    }
  };

  markAllDriverMessageAsRead = () => {
    const onChatDriverId = this.state.driver?.driverId;
    this.props.DispatchStore.clearDriverUnreadCount(onChatDriverId);
    this.props.DispatchStore.updateNotificationReadStatus(onChatDriverId);
    this.state.messageList.forEach((message) => {
      if (message.sender.toUpperCase() === onChatDriverId.toUpperCase() && !message.isRead) {
        this.markDriverMessageAsRead(message);
      }
    });
  };

  sendMessage = (messageInfo) => {
    const {
      message,
      isUrgent = false,
      choice = [],
      parentMessageId,
      metadata,
    } = messageInfo;
    const inputObj = {
      terminalCode: this.props.userData.userProfile.terminal.code,
      driverId: this.state.driver?.driverId,
      text: sanitizeInput(message),
      eventDateTime: new Date(),
      urgent: isUrgent,
      choice,
      messageId: uuidv4().toUpperCase(),
      parentMessageId: parentMessageId || null,
      userId: this.props.userData.userProfile.userId,
      metadata,
    };
    messageInfo["messageId"] = inputObj.messageId;
    messageInfo["message"] = inputObj.text;
    postData("MessageToDriver", inputObj).then((response) => {
      if (response && Math.trunc(response.status / 100) === 2) {
        const messageList = [...this.state.messageList, messageInfo];
        const newMessageList = messageList
          .map((msg) => {
            if (msg.messageId !== parentMessageId) {
              return msg;
            }
          })
          .filter(function (el) {
            return el != null;
          });
        this.markAllDriverMessageAsRead();
        this.setState({
          messageList: newMessageList,
          unReadCount: 0,
          isChoiceMessageDisabled: false,
        });
      }
    });
  };

  onMessageFromDriver = (driverMessageString) => {
    const onChatDriverId = this.state.driver?.driverId;
    const driverMessage = JSON.parse(driverMessageString);
    const matchRoute = this.props.DispatchStore.currentActiveRoutes.find(
      (route) =>
        route.driverId.toUpperCase() === driverMessage.sender.toUpperCase(),
    );
    if (matchRoute && driverMessage.message.length > 0) {
      if (matchRoute.driverId === onChatDriverId) {
        if (driverMessage.parentMessageId) {
          const matchmsg = this.state.messageList.findIndex(
            (msg) =>
              driverMessage.parentMessageId.toUpperCase() ===
              msg.messageId.toUpperCase(),
          );
          if (matchmsg !== -1) {
            const newMessageList = this.formateMessageList(driverMessage);
            this.setState(prevState => ({
              ...prevState,
              messageList: [
                ...newMessageList,
                {
                  type: "text",
                  parentMessage: prevState.messageList[matchmsg],
                  ...driverMessage,
                },
              ],
              unReadCount: prevState.unReadCount + 1,
            }));
          }
        } else {
          this.setState(prevState => ({
            ...prevState,
            messageList: [
              ...prevState.messageList,
              {
                type: "text",
                parentMessage: {},
                ...driverMessage,
              },
            ],
            unReadCount: prevState.unReadCount + 1,
          }));
        }
        this.markDriverMessageAsRead(driverMessage);
        this.props.DispatchStore.updateNotificationReadStatus(onChatDriverId);
      }
    }
  };

  markDriverMessageAsRead = (message) => {
    const requestObj = {
      terminalCode: this.props.userData.userProfile.terminal.code,
      driverId: message.sender,
      messageId: message.messageId,
      eventDateTime: new Date(),
      userId: this.props.userData.userProfile.userId,
    };

    postData("DispatcherReadReceipt", requestObj).then((response) => {
      if (Math.trunc(response.status / 100) === 2) {
        const updatedMessageList = this.state.messageList.map((msg) => {
          if (msg.messageId.toUpperCase() === message.messageId.toUpperCase()) {
            msg.isRead = true;
          }
          return msg;
        });
        this.setState({
          messageList: updatedMessageList,
        });
      }
    });
  };

  formateMessageList = (driverMessage) => {
    return this.state.messageList
      .map((msg) => {
        if (msg.messageId !== driverMessage.parentMessageId) {
          return msg;
        }
      })
      .filter(function (el) {
        return el != null;
      });
  };

  componentWillReceiveProps(nextProps) {
    if (this.props.mute) {
      return;
    }
  }

  handleCannedMessageClick = (showCannedMessages) => {
    this.setState({
      openCannedMessages: showCannedMessages,
    });
  };

  handleChoiceMessageClick = (showChoiceMessages) => {
    this.setState({
      openChoiceMessages: showChoiceMessages,
    });
  };

  handleChatWindowClose = () => {
    this.markAllDriverMessageAsRead();
    this.props.onClose();
  }

  handleMenuClose = () => {
    this.setState({
      anchorEl: null,
    });
  };

  handleMenuOpen = (event) => {
    this.setState({
      anchorEl: event.currentTarget,
    });
  };

  handleMenuOptionClick = (type) => {
    if (type === 'onChoiceMessage') {
      this.handleChoiceMessageClick(true);
    } else if (type === 'onCannedMessage') {
      this.handleCannedMessageClick(true);
    } else if (type === 'onMessageHistory'){
      this.openMessageHistoryClick();
    }
    this.handleMenuClose();
  }

  openMessageHistoryClick = () => {
    this.setState({openMessageHistory: true})
  }

  closeMessageHistoryClick = () => {
    this.setState({openMessageHistory: false})
  }

  getDriverInfoDetails = () => {
    const { driver, unReadCount } = this.state;
    const pendingCustomers =
      this.props.DispatchStore.getDriverDetails(driver?.driverId)?.pendingStops?.map(
        (stop) => stop.name
      ) ?? [];
    return {
      pendingCustomers,
      name: driver?.driverName,
      unReadCount,
    };
  };

  isMessageHistoryDisabled = () => {
    return !this.props.DispatchStore.dispatchedDriversList.some(
      (option) => option.value === this.state.driver?.driverId
    );
  };

  render() {
    const { classes } = this.props;
    const { loadingMessages, openMessageHistory } = this.state;
    const {code: currentTerminalCode, offset: currentTerminalOffset} = this.props.userData.userProfile.terminal;
    const driverInfo = this.getDriverInfoDetails();
    return (
      <>
        <Header title={this.state.driver?.driverName}>
          <IconButton aria-label="edit" className={classes.editIcon} onClick={this.handleMenuOpen}>
            <Tooltip title="Show Controls">
              <MoreVert />
            </Tooltip>
          </IconButton>
          <MessageActionMenu
            anchorEl={this.state.anchorEl}
            handleMenuClose={this.handleMenuClose}
            handleMenuOptionClick={this.handleMenuOptionClick}
            isChoiceMessageDisabled={this.state.isChoiceMessageDisabled}
            disableMessageHistory={this.isMessageHistoryDisabled()}
          />
          <CloseButton onClick={this.handleChatWindowClose} />
        </Header>
        <ChatWindow
          loadingMessages={loadingMessages}
          messageList={this.state.messageList}
          onUserInputSubmit={this.sendMessage}
          driverInfo={driverInfo}
          classes={classes}
          openCannedMessages={this.state.openCannedMessages}
          handleCannedMessageClick={this.handleCannedMessageClick}
          openChoiceMessages={this.state.openChoiceMessages}
          disableChoiceMessageIcon={this.disableChoiceMessageIcon}
          handleChoiceMessageClick={this.handleChoiceMessageClick}
          currentTerminalOffset={currentTerminalOffset}
          currentDispatcherName={AuthService.getUsername()}
        />
        {openMessageHistory && (
          <MessageHistory
            onClose={this.closeMessageHistoryClick}
            driverOptions={this.props.DispatchStore.activeDispatchedDriversList}
            defaultTerminalCode={currentTerminalCode}
            defaultTerminalOffset={currentTerminalOffset}
            defaultDriver={this.state.driver?.driverId}
            driverInfo={driverInfo}
            defaultDateRange={getDefaultDateRange()}
          />
        )}
      </>
    );
  }
}


export default compose(
  withTheme(),
  withStyles(styles),
  withUserProfile,
  WithChatWindow,
)(ChatContainer);
